export const wapiLegal = {
  fr: {
    switchLink: {
      to: "/politique-legale/talo",
      text: "Voir la politique légale de Talo",
    },
    blocks: [
      { type: "h2", text: "Wapi - Politique Légale" },
      {
        type: "h3",
        text: "(Confidentialité, Sécurité des données et Conditions d'utilisation)",
      },
      { type: "p", html: "<strong>Dernière mise à jour :</strong> 9 mai 2026" },
      { type: "h3", text: "1. Introduction" },
      {
        type: "p",
        text: "L'application Wapi est une plateforme permettant aux utilisateurs de rechercher la disponibilité de médicaments dans des pharmacies partenaires et de localiser des points de vente proches de leur position.",
      },
      {
        type: "p",
        text: "Wapi a pour objectif de faciliter l'accès à l'information sur la disponibilité des produits pharmaceutiques tout en améliorant la visibilité des pharmacies partenaires.",
      },
      {
        type: "p",
        text: "En utilisant Wapi, vous acceptez la présente politique légale comprenant :",
      },
      {
        type: "ul",
        items: [
          "La politique de confidentialité",
          "Les mesures de sécurité des données",
          "Les conditions d'utilisation",
        ],
      },
      { type: "h3", text: "2. Politique de confidentialité" },
      { type: "h4", text: "2.1 Données collectées" },
      {
        type: "p",
        text: "Wapi peut collecter et traiter uniquement les données suivantes :",
      },
      { type: "h4", text: "Données de recherche" },
      {
        type: "ul",
        items: [
          "Médicaments recherchés",
          "Pharmacies consultées",
          "Historique des recherches",
        ],
      },
      { type: "h4", text: "Données de localisation" },
      {
        type: "ul",
        items: [
          "Position géographique approximative ou précise (avec autorisation de l'utilisateur)",
          "Ville ou zone de recherche",
        ],
      },
      { type: "h4", text: "2.2 Utilisation des données" },
      { type: "p", text: "Les données sont utilisées pour :" },
      {
        type: "ul",
        items: [
          "Afficher les pharmacies proches de l'utilisateur",
          "Rechercher la disponibilité des médicaments",
          "Améliorer la pertinence des résultats",
          "Améliorer l'expérience utilisateur",
          "Assurer le bon fonctionnement de la plateforme",
        ],
      },
      { type: "h4", text: "2.3 Stockage des données" },
      { type: "p", text: "Les données sont traitées de manière sécurisée." },
      {
        type: "p",
        text: "Certaines données peuvent être utilisées temporairement pour améliorer la rapidité et la précision des résultats affichés dans l'application.",
      },
      { type: "h4", text: "2.4 Partage des données" },
      { type: "p", text: "Nous ne vendons aucune donnée." },
      { type: "p", text: "Les informations peuvent être partagées uniquement avec :" },
      {
        type: "ul",
        items: [
          "Les pharmacies partenaires",
          "Les services techniques nécessaires au fonctionnement de la plateforme",
        ],
      },
      { type: "h4", text: "2.5 Exactitude des informations" },
      {
        type: "p",
        text: "Les informations concernant la disponibilité des médicaments dépendent des pharmacies partenaires.",
      },
      {
        type: "p",
        text: "Wapi ne garantit pas la disponibilité permanente ou immédiate d'un médicament affiché.",
      },
      {
        type: "p",
        text: "Les utilisateurs doivent confirmer directement auprès des pharmacies avant tout déplacement.",
      },
      { type: "h4", text: "2.6 Conservation des données" },
      {
        type: "p",
        text: "Les données sont conservées uniquement pendant la durée nécessaire au fonctionnement du service.",
      },
      { type: "h4", text: "2.7 Gestion des données" },
      { type: "p", text: "Les utilisateurs peuvent :" },
      {
        type: "ul",
        items: [
          "Désactiver la localisation depuis leur appareil",
          "Supprimer les données de l'application en la désinstallant",
        ],
      },
      { type: "h4", text: "2.8 Confidentialité des enfants" },
      {
        type: "p",
        text: "Wapi n'est pas destiné aux enfants de moins de 13 ans sans supervision d'un responsable légal.",
      },
      { type: "h3", text: "3. Sécurité des données" },
      { type: "h4", text: "3.1 Protection du service" },
      {
        type: "ul",
        items: [
          "Contrôle des accès",
          "Surveillance des usages abusifs",
          "Protection contre les utilisations malveillantes",
        ],
      },
      { type: "h4", text: "3.2 Protection des informations" },
      {
        type: "ul",
        items: [
          "Sécurisation des communications",
          "Protection contre les accès non autorisés",
          "Mesures de sécurité internes du système",
        ],
      },
      { type: "h3", text: "4. Conditions d'utilisation" },
      { type: "h4", text: "4.1 Acceptation" },
      { type: "p", text: "En utilisant Wapi, vous acceptez ces conditions." },
      { type: "h4", text: "4.2 Utilisation autorisée" },
      { type: "p", text: "Wapi doit être utilisé uniquement pour :" },
      {
        type: "ul",
        items: [
          "Rechercher des médicaments",
          "Consulter les pharmacies partenaires",
          "Accéder aux informations disponibles",
        ],
      },
      { type: "h4", text: "4.3 Utilisation interdite" },
      { type: "p", text: "Il est interdit de :" },
      {
        type: "ul",
        items: [
          "Utiliser Wapi à des fins illégales",
          "Perturber le fonctionnement de l'application",
          "Tenter d'exploiter ou copier les données de la plateforme",
        ],
      },
      { type: "h4", text: "4.4 Limitation de responsabilité" },
      { type: "p", text: 'Wapi est fourni "tel quel".' },
      {
        type: "p",
        text: "Wapi ne remplace pas un professionnel de santé et ne constitue pas un service médical d'urgence.",
      },
      { type: "p", text: "Les informations sont fournies à titre informatif uniquement." },
      { type: "h4", text: "4.5 Disponibilité des médicaments" },
      { type: "p", text: "Les stocks peuvent varier selon :" },
      {
        type: "ul",
        items: [
          "les ventes en pharmacie",
          "les mises à jour des systèmes des pharmacies",
        ],
      },
      {
        type: "p",
        text: "Wapi ne peut garantir l'exactitude en temps réel des disponibilités.",
      },
      { type: "h4", text: "4.6 Modifications" },
      { type: "p", text: "Cette politique peut être mise à jour à tout moment." },
      { type: "h3", text: "5. Contact" },
      {
        type: "p",
        html: 'Email : <a href="mailto:support@talohub.store">support@talohub.store</a>',
      },
      { type: "h3", text: "Résumé" },
      {
        type: "ul",
        items: [
          "Aucune donnée personnelle collectée",
          "Aucune donnée technique utilisateur stockée",
          "Données limitées aux recherches et localisation",
          "Aucune vente de données",
          "Wapi est un outil informatif de recherche de médicaments",
        ],
      },
    ],
  },
  en: {
    switchLink: {
      to: "/politique-legale/talo",
      text: "View Talo legal policy",
    },
    blocks: [
      { type: "h2", text: "Wapi - Legal Policy" },
      {
        type: "h3",
        text: "(Privacy, Data Security, and Terms of Use)",
      },
      { type: "p", html: "<strong>Last updated:</strong> May 9, 2026" },
      { type: "h3", text: "1. Introduction" },
      {
        type: "p",
        text: "The Wapi application is a platform that allows users to search for medication availability at partner pharmacies and locate nearby points of sale.",
      },
      {
        type: "p",
        text: "Wapi aims to make pharmaceutical product availability information easier to access while improving visibility for partner pharmacies.",
      },
      {
        type: "p",
        text: "By using Wapi, you accept this legal policy, which includes:",
      },
      {
        type: "ul",
        items: [
          "The privacy policy",
          "Data security measures",
          "Terms of use",
        ],
      },
      { type: "h3", text: "2. Privacy Policy" },
      { type: "h4", text: "2.1 Data Collected" },
      {
        type: "p",
        text: "Wapi may collect and process only the following data:",
      },
      { type: "h4", text: "Search data" },
      {
        type: "ul",
        items: [
          "Medications searched",
          "Pharmacies viewed",
          "Search history",
        ],
      },
      { type: "h4", text: "Location data" },
      {
        type: "ul",
        items: [
          "Approximate or precise geographic location (with user permission)",
          "City or search area",
        ],
      },
      { type: "h4", text: "2.2 Use of Data" },
      { type: "p", text: "Data is used to:" },
      {
        type: "ul",
        items: [
          "Show pharmacies near the user",
          "Search medication availability",
          "Improve result relevance",
          "Improve user experience",
          "Ensure proper platform operation",
        ],
      },
      { type: "h4", text: "2.3 Data Storage" },
      { type: "p", text: "Data is processed securely." },
      {
        type: "p",
        text: "Some data may be used temporarily to improve the speed and accuracy of results displayed in the application.",
      },
      { type: "h4", text: "2.4 Data Sharing" },
      { type: "p", text: "We do not sell any data." },
      { type: "p", text: "Information may only be shared with:" },
      {
        type: "ul",
        items: [
          "Partner pharmacies",
          "Technical services required for platform operation",
        ],
      },
      { type: "h4", text: "2.5 Information Accuracy" },
      {
        type: "p",
        text: "Information about medication availability depends on partner pharmacies.",
      },
      {
        type: "p",
        text: "Wapi does not guarantee permanent or immediate availability of a displayed medication.",
      },
      {
        type: "p",
        text: "Users must confirm directly with pharmacies before traveling.",
      },
      { type: "h4", text: "2.6 Data Retention" },
      {
        type: "p",
        text: "Data is retained only for as long as necessary for the service to function.",
      },
      { type: "h4", text: "2.7 Data Management" },
      { type: "p", text: "Users may:" },
      {
        type: "ul",
        items: [
          "Disable location from their device",
          "Delete application data by uninstalling the app",
        ],
      },
      { type: "h4", text: "2.8 Children's Privacy" },
      {
        type: "p",
        text: "Wapi is not intended for children under 13 without supervision by a legal guardian.",
      },
      { type: "h3", text: "3. Data Security" },
      { type: "h4", text: "3.1 Service Protection" },
      {
        type: "ul",
        items: [
          "Access control",
          "Monitoring of abusive use",
          "Protection against malicious use",
        ],
      },
      { type: "h4", text: "3.2 Information Protection" },
      {
        type: "ul",
        items: [
          "Secured communications",
          "Protection against unauthorized access",
          "Internal system security measures",
        ],
      },
      { type: "h3", text: "4. Terms of Use" },
      { type: "h4", text: "4.1 Acceptance" },
      { type: "p", text: "By using Wapi, you accept these terms." },
      { type: "h4", text: "4.2 Permitted Use" },
      { type: "p", text: "Wapi must be used only to:" },
      {
        type: "ul",
        items: [
          "Search for medications",
          "View partner pharmacies",
          "Access available information",
        ],
      },
      { type: "h4", text: "4.3 Prohibited Use" },
      { type: "p", text: "It is prohibited to:" },
      {
        type: "ul",
        items: [
          "Use Wapi for illegal purposes",
          "Disrupt the application's operation",
          "Attempt to exploit or copy platform data",
        ],
      },
      { type: "h4", text: "4.4 Limitation of Liability" },
      { type: "p", text: 'Wapi is provided "as is".' },
      {
        type: "p",
        text: "Wapi does not replace a healthcare professional and is not an emergency medical service.",
      },
      { type: "p", text: "Information is provided for informational purposes only." },
      { type: "h4", text: "4.5 Medication Availability" },
      { type: "p", text: "Stock levels may vary depending on:" },
      {
        type: "ul",
        items: ["pharmacy sales", "updates from pharmacy systems"],
      },
      {
        type: "p",
        text: "Wapi cannot guarantee real-time accuracy of availability.",
      },
      { type: "h4", text: "4.6 Changes" },
      { type: "p", text: "This policy may be updated at any time." },
      { type: "h3", text: "5. Contact" },
      {
        type: "p",
        html: 'Email: <a href="mailto:support@talohub.store">support@talohub.store</a>',
      },
      { type: "h3", text: "Summary" },
      {
        type: "ul",
        items: [
          "No personal data collected",
          "No user technical data stored",
          "Data limited to searches and location",
          "No sale of data",
          "Wapi is an informational medication search tool",
        ],
      },
    ],
  },
};
